import { lazyNamed } from 'src/utils/lazyNamed';

export default {
  WebsiteGroupsList: lazyNamed(() => import('./containers/WebsiteGroupsList'), 'WebsiteGroupsList'),
  WebsiteGroupForm: lazyNamed(() => import('./containers/WebsiteGroupForm'), 'WebsiteGroupForm'),
};
